import { createContext, useContext } from "react";

/**
 * Whether the installation accepts changes. The license can make it read-only; buttons that change
 * data are marked `write` and turn themselves off with an explanation instead of failing when pressed.
 */
export interface Writable {
  readOnly: boolean;
  /** Short reason for a tooltip, e.g. "Changes are turned off while the license is expired." */
  reason: string | undefined;
}

export const WritableContext = createContext<Writable>({ readOnly: false, reason: undefined });

export const useWritable = () => useContext(WritableContext);
